import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { deleteAmenity, getAllAmenity } from '../../store/actions/adminAction'
import { Link } from 'react-router-dom'
import Loader from '../../components/loader/Loader'
import moment from 'moment'

const Users = () => {
    const dispatch = useDispatch()
    const allAmenities = useSelector(state => state.admin.allAmenities)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        let data = {}
        dispatch(getAllAmenity(data, (value) => setLoading(value)))
    }, [])


    const onDeleteAmenity = (amenityId) => {
        if (window.confirm("Are you sure you want to delete?")) {
            let data = {}
            dispatch(
                deleteAmenity(
                    amenityId,
                    (value) => setLoading(value),
                    () => dispatch(getAllAmenity(data, (value) => setLoading(value)))
                )
            )
        }
    }


    return (
        <div className="admin-body">
            <div className="admin-header">
                <div className="flex justify-between">
                    <h1 className="heading text-lg font-bold mb-3">Amenities</h1>
                    <Link to="/admin/amenities/add">
                        <div className='bg-gray-300 rounded padding px-4 py-1 text-sm cursor-pointer hover:bg-gray-900 hover:text-white'>Add Amenity</div>
                    </Link>
                </div>
            </div>

            {
                loading ?
                    <div className="flex w-100 justify-center py-40">
                        <Loader width={"w-10"} className={"text-gray-200"} />
                    </div>
                    :
                    <div class="bg-white shadow-md rounded fade-in-bottom">
                        <table class="min-w-max w-full table-auto">
                            <thead>
                                <tr class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                                    <th class="py-3 w-28 px-6 text-left">Icon</th>
                                    <th class="py-3 px-6 text-left">Amenity</th>
                                    <th class="py-3 px-6 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm">
                                {allAmenities?.map(amenity =>
                                    <tr class="border-b border-gray-200 hover:bg-gray-100">
                                        <td class="py-3 px-6 text-left">
                                            <div class="flex items-center">
                                                <img src={amenity.amenityImage} className='w-5 mr-5 rounded' />
                                            </div>
                                        </td>
                                        <td class="py-3 px-6 text-left">
                                            <div class="flex items-center">
                                                <span>{amenity.amenityTitle}</span>
                                            </div>
                                        </td>

                                        <td class="py-3 px-6 text-center">
                                            <div class="flex item-center justify-center">
                                                {/* <div class="w-4 mr-2 transform hover:text-red-500 hover:scale-110">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                    </svg>
                                                </div> */}
                                                <div class="w-4 mr-2 transform hover:text-red-500 hover:scale-110">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                    </svg>
                                                </div>
                                                <div class="w-4 mr-2 transform hover:text-red-500 hover:scale-110" onClick={() => onDeleteAmenity(amenity._id)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>}
        </div>


    )
}

export default Users